module.exports = __webpack_public_path__ + "02_short_black.0d82e7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_short_black.png
// module id = Rijs
// module chunks = 0